export default __webpack_public_path__ + "static/media/no_show_model.5d45e637.jpg";